import type { ButtonHTMLAttributes } from "react";
import { Loader } from "../loader";

interface LoadingButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  loadingLabel?: string;
  loaderSize?: number;
}

export function LoadingButton({
  isLoading = false,
  loadingLabel = "Carregando",
  loaderSize = 16,
  disabled,
  className = "",
  children,
  ...props
}: LoadingButtonProps) {
  const isDisabled = disabled || isLoading;
  const baseClass =
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 focus-visible:ring-offset-2";

  return (
    <button
      {...props}
      disabled={isDisabled}
      aria-busy={isLoading}
      className={`${baseClass} ${className} ${
        isDisabled ? "opacity-60 cursor-not-allowed" : ""
      }`}
    >
      {isLoading ? (
        <span className="flex items-center justify-center">
          <Loader size={loaderSize} />
          <span className="sr-only">{loadingLabel}</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
}
